var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"k2Image"},[(_vm.link)?_c('a',{on:{"click":function($event){return _vm.handleLink()}}},[_c('img',{attrs:{"src":_vm.src,"height":this.height}})]):_c('div',[_c('img',{attrs:{"src":_vm.src,"height":this.height},on:{"error":_vm.handleImageError}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }